module.exports = __webpack_public_path__ + "media/icons/flag-afea98d4.png";